import axios from "axios";

const BASE_URL = `/m-1/meeting-localizations`;

export const LocalizationService = {
    get: async () => {
        return await axios.get(`${BASE_URL}`)
    },

    getByID: async (id) => {
        return await axios.get(`${BASE_URL}/${id}`);
    },

    getMeetings: async (id, filters = []) => {
        let hit = `${BASE_URL}/${id}/meetings?`;

        filters.forEach((filter) => {
            hit += `${filter.key}=${filter.value}&`;
        });

        return await axios.get(hit);
    }
};
